var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mx-2",attrs:{"label":_vm.label,"hide-details":"","outline":"","height":"44","readonly":true,"rules":_vm.rules},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})
}
var staticRenderFns = []

export { render, staticRenderFns }